export default __webpack_public_path__ + "videos/login_page_logo.png";